import {DrugStudy} from '@app/models/form/drug-study.model';
import {Mgtfe} from '@app/models/form/mgtfe.model';
import {FordocUser} from '@app/models/form/fordoc-user.model';
import {ExclusiveDomain} from '@app/models/form/exclusive-domain.model';
import {MedicalDevice} from '@app/models/form/medical-device.model';
import {OtherPersons} from '@app/models/form/other-persons.model';
import {SpecificH} from '@app/models/form/specific-h.model';
import {SpecificX} from '@app/models/form/specific-x.model';
import {Decision} from '@app/models/decision.model';
import {StatusConst} from '@app/models/form/status.const';
import {MethodologyUsed} from '@app/models/form/methodologies-used.model';

export class MgtfeForm {

    id: number;
    hasPdf: boolean;
    researcher: FordocUser;
    sponsor: FordocUser;
    mgtfe: Mgtfe;
    exclusiveDomain: ExclusiveDomain;
    drugStudy: DrugStudy;
    medicalDevice: MedicalDevice;
    otherPersons: OtherPersons;
    specificH: SpecificH;
    specificX: SpecificX;
    decisions: Decision;
    comment: string;
    status: string;
    pdfUrl: string;
    methodologyUsed: MethodologyUsed;
    dateSubmitted: Date;

    constructor() {
        this.researcher = new FordocUser();
        this.sponsor = new FordocUser();
        this.mgtfe = new Mgtfe();
        this.exclusiveDomain = new ExclusiveDomain();
        this.drugStudy = new DrugStudy();
        this.medicalDevice = new MedicalDevice();
        this.otherPersons = new OtherPersons();
        this.specificH = new SpecificH();
        this.specificX = new SpecificX();
        this.decisions = new Decision();
        this.comment = "";
        this.status = StatusConst.DRAFT;
        this.methodologyUsed = new MethodologyUsed();
        this.dateSubmitted = null;
    }

}
